import { call, put } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { signDocumentSuccessful, signDocumentFailed } from '../actions';
import processError from '../../../utils/processError';
import loadSignUploadDocument from './loadSignUploadDocument';

export default function* signDocument(action) {
  try {
    const { cert, document } = action.payload;
    const signature = yield loadSignUploadDocument(document, cert, true);
    if (typeof signature !== 'string') {
      yield put(signDocumentSuccessful(signature));
      yield call(resolveActionPromise(action, signature));
      return signature;
    }
    yield put(signDocumentFailed(false));
    yield call(rejectActionPromise(action, false));
    return false;
  } catch (e) {
    yield put(signDocumentFailed(false));
    yield call(rejectActionPromise(action, e && e.message ? e.message : ''));
    yield processError(e);
    return false;
  }
}
